"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCachedSelectors = exports.clearComputeCache = exports.CacheManager = exports.NO_CACHE = void 0;
const compute_cache_manager_1 = require("../compute_manager/compute_cache_manager");
const formula_parser_1 = require("../formula_parser");
const store_1 = require("../exports/store");
const selectors_1 = require("../exports/store/selectors");
const cache_1 = require("./cache");
var cache_2 = require("./cache");
Object.defineProperty(exports, "NO_CACHE", { enumerable: true, get: function () { return cache_2.NO_CACHE; } });
exports.CacheManager = {
    calcDsCache: (state, snapshot) => {
        const { datasheetId, recordMap, meta: { fieldMap } } = snapshot;
        if (!datasheetId) {
            return;
        }
        for (const fieldId in fieldMap) {
            for (const recordId in recordMap) {
                const cellCache = store_1.Selectors.calcCellValueAndString({
                    state,
                    snapshot,
                    fieldId,
                    recordId,
                    datasheetId,
                    withError: false,
                    ignoreFieldPermission: true
                });
                exports.CacheManager.setCellCache(datasheetId, fieldId, recordId, cellCache);
            }
        }
    },
    clearDsCache: (dsId) => {
        return cache_1.cache.removeDsCache(dsId);
    },
    removeCellCache: (dsId, fieldId, recordId) => {
        return cache_1.cache.removeCellCache(dsId, fieldId, recordId);
    },
    removeCellCacheByRecord: (dsId, recordId) => {
        return cache_1.cache.removeCellCacheByRecord(dsId, recordId);
    },
    getCellCache: (dsId, fieldId, recordId) => {
        return cache_1.cache.getCellCache(dsId, fieldId, recordId);
    },
    setCellCache: (dsId, fieldId, recordId, cellCache) => {
        return cache_1.cache.addCellCache(dsId, fieldId, recordId, cellCache);
    },
    clear: () => {
        cache_1.cache.clearCache();
    }
};
if (!global.process) {
    global.__cache__ = cache_1.cache;
}
const clearComputeCache = (dstId) => {
    formula_parser_1.ExpCache.clearAll();
    if (dstId) {
        exports.CacheManager.clearDsCache(dstId);
    }
    else {
        exports.CacheManager.clear();
    }
    if (compute_cache_manager_1.computeCache) {
        compute_cache_manager_1.computeCache.clear();
    }
};
exports.clearComputeCache = clearComputeCache;
/**
 * clear cached selectors
 */
const clearCachedSelectors = () => {
    selectors_1.getCurrentView.clearCache();
    selectors_1.getFilterInfo.clearCache();
    selectors_1.getFieldMap.clearCache();
    selectors_1.getFieldMapIgnorePermission.clearCache();
    selectors_1.getVisibleColumns.clearCache();
    selectors_1.getCalendarVisibleColumns.clearCache();
    selectors_1.getOrgChartVisibleColumns.clearCache();
    selectors_1.getGanttVisibleColumns.clearCache();
};
exports.clearCachedSelectors = clearCachedSelectors;
//# sourceMappingURL=index.js.map